import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import type { AppDispatch } from '../store'
import { setDailyLimit } from '../store/slices/evaluationSlice'
import { verifyCheckoutSession } from '../api/client'
import { trackPurchase } from '../lib/analytics'

export default function SubscriptionSuccessPage() {
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  const [searchParams] = useSearchParams()
  const [status, setStatus] = useState<'verifying' | 'activated' | 'error'>('verifying')

  useEffect(() => {
    const sessionId = searchParams.get('session_id')
    if (!sessionId) {
      setStatus('error')
      return
    }

    verifyCheckoutSession(sessionId)
      .then((result) => {
        if (result.activated) {
          setStatus('activated')
          dispatch(setDailyLimit(-1))
          trackPurchase(4.99, sessionId)
          setTimeout(() => navigate('/practice'), 2000)
        } else {
          setStatus('error')
        }
      })
      .catch(() => setStatus('error'))
  }, [searchParams, dispatch, navigate])

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="glass-card p-8 text-center max-w-md">
        {status === 'verifying' && (
          <>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">Verifying payment...</h1>
            <p className="text-gray-500 dark:text-gray-400">Please wait a moment.</p>
          </>
        )}
        {status === 'activated' && (
          <>
            <div className="w-16 h-16 rounded-full bg-emerald-500/20 flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-emerald-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">Subscription Activated!</h1>
            <p className="text-gray-500 dark:text-gray-400">You now have unlimited evaluations. Redirecting to practice...</p>
          </>
        )}
        {status === 'error' && (
          <>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">Something went wrong</h1>
            <p className="text-gray-500 dark:text-gray-400 mb-4">We couldn't verify your payment. Please try again or contact support.</p>
            <button onClick={() => navigate('/practice')} className="btn-primary text-sm py-2 px-6">
              Back to Practice
            </button>
          </>
        )}
      </div>
    </div>
  )
}
